// extracted by mini-css-extract-plugin
export default {"information":"informationTi7B5"};